import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Button, { Props as ButtonProps } from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import { ProgressBar } from 'components/atoms/ProgressBar/ProgressBar';
import Txt from 'components/atoms/Txt/Txt';
import { graphql } from 'react-relay';
import useLiveFragment from 'relay/useLiveFragment';
import classes from './CurrentEarningsCard.module.scss';

export type Props = {
  currentEarningsRef: any;
  buttonText: string;
  buttonHref: string;
  buttonSize?: ButtonProps['buttonSize'];
  buttonAlwaysEnabled?: boolean;
  className?: string;
};

const fragmentSpec = graphql`
  fragment CurrentEarningsCard_currentEarnings on WalletBalance
  @refetchable(queryName: "CurrentEarningsCardRefetchQuery") {
    amount {
      subUnitAmount
    }
  }
`;

export default function CurrentEarningsCard({
  currentEarningsRef,
  buttonText,
  buttonHref,
  buttonSize,
  buttonAlwaysEnabled,
  className,
}: Props) {
  const data = useLiveFragment(fragmentSpec, currentEarningsRef);

  return (
    <Card className={clsx(classes.root, className)}>
      <Heading level={3} className={clsx(classes.heading)}>
        Your Current Earnings
      </Heading>
      <div className={clsx(classes.progress)}>
        <ProgressBar
          className={clsx(classes.progressBar)}
          style={'circular'}
          value={data.amount.subUnitAmount}
          max={550}
        />
        <Txt skipTranslation className={clsx(classes.points)}>{`${data.amount.subUnitAmount}`}</Txt>
      </div>
      <Button
        component={A}
        className={clsx(classes.redeemButton)}
        disabled={!buttonAlwaysEnabled && data.amount.subUnitAmount < 550} // TODO: This value needs to be fetched dynamically for each country
        buttonSize={buttonSize || 'large'}
        href={buttonHref}
      >
        <Txt>{buttonText}</Txt>
      </Button>
    </Card>
  );
}
